import React from "react";
import { useNavigate } from "react-router-dom";

export default function MaharajaLogo({ text, limited, servise }) {
  const navigate = useNavigate();

  return (
    <div
      className="flex flex-shrink-0 cursor-pointer items-center"
      onClick={() => {
        navigate("/");
        window.scrollTo(0, 0);
      }}
    >
      <h4
        className={`whitespace-nowrap bg-gradient-to-r from-red-600 via-red-500 to-orange-500 bg-clip-text text-2xl font-extrabold tracking-tight text-transparent ${text}`}
      >
        Maharaja{" "}
        <span className="font-bold">
          {servise || "Flights"} {limited}
        </span>
      </h4>
    </div>
  );
}